import React from 'react'
import { ClearIndicatorProps, components } from 'react-select'
import { makeStyles } from 'tss-react/mui'

import IconButton from '@mui/material/IconButton'
import { J2Multiply } from '@e3dc-react/icons'

const useSelectStyles = makeStyles()(() => ({
  button: {
    padding: 0,
  },
}))

/**
 * This component displays a clear indicator (cross)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ClearIndicator = (props: ClearIndicatorProps<any, any>): React.ReactElement => {
  const { classes } = useSelectStyles()
  return (
    <components.ClearIndicator {...props}>
      <IconButton size="large" className={classes.button}>
        <J2Multiply />
      </IconButton>
    </components.ClearIndicator>
  )
}

export default ClearIndicator
